function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isDate, isNumber, isString } from "./type";
/**
 * Usage
 * 1 设置5秒后过期
 *    ExpireLocalStorage.setItem('test', 'hello world', 5000); 
 * 2 直接设置过期时间
 *    const specificTime = new Date('2024-01-01 00:00:00');
 *    ExpireLocalStorage.setItem('test2', 'hello again, I will expire in 2024-01-01 00:00:00', specificTime);
 * 3 直接设置时间字符 必须确保字符串被正确解析为日期
 *    const dateStr = '2024-01-01 00:00:00';
 *    ExpireLocalStorage.setItem('test3', 'hello again, I will expire in 2024-01-01 00:00:00', dateStr);
 */
var ExpireLocalStorage = /*#__PURE__*/function () {
  function ExpireLocalStorage() {
    _classCallCheck(this, ExpireLocalStorage);
  }
  _createClass(ExpireLocalStorage, null, [{
    key: "setItem",
    value:
    /**
     * 设置带有过期时间的项
     * @param key localStorage item key
     * @param value value
     * @param ttl Time To Live
     */
    function setItem(key, value, expiry) {
      try {
        var now = new Date();
        var expiryTime;
        // 无论传入的是什么，都转化为时间戳
        if (isNumber(expiry)) {
          expiryTime = now.getTime() + expiry; // expiry为毫秒数
        } else if (isDate(expiry)) {
          expiryTime = expiry.getTime(); // expiry为Date对象
        } else if (isString(expiry)) {
          var date = new Date(expiry);
          if (!isNaN(date.getTime())) {
            // 确保字符串被正确解析为日期
            expiryTime = date.getTime();
          } else {
            throw new Error('Invalid date string');
          }
        } else {
          throw new Error('Invalid expiry type');
        }
        var item = {
          value: value,
          expiry: expiryTime
        };
        if (typeof window === 'undefined') {
          // 没有window 对象，请在浏览器环境下使用
          throw new Error('There is no window object, please use it in a browser environment');
        } else {
          window.localStorage.setItem(ExpireLocalStorage.prefix + key, JSON.stringify(item));
        }
      } catch (error) {
        // 假设解析或处理存储项时出错 并记录错误。
        if (typeof window !== 'undefined') {
          window.console.error('Failed to set localStorage:', error);
        }
        return null;
      }
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      try {
        var itemStr = null;
        if (typeof window === 'undefined') {
          // 没有window 对象，请在浏览器环境下使用
          throw new Error('There is no window object, please use it in a browser environment');
        } else {
          itemStr = window.localStorage.getItem(ExpireLocalStorage.prefix + key);
        }
        if (!itemStr) {
          return null;
        }
        var item = JSON.parse(itemStr);
        var now = new Date().getTime();
        // 由于设置的时候进行了转化处理，这里得到的必然是时间戳
        if (now > Number(item.expiry)) {
          if (typeof window === 'undefined') {
            // 没有window 对象，请在浏览器环境下使用
            throw new Error('There is no window object, please use it in a browser environment');
          } else {
            window.localStorage.removeItem(ExpireLocalStorage.prefix + key);
          }
          return null;
        }
        return item.value;
      } catch (error) {
        // 假设解析或处理存储项时出错，我们将其从localStorage中移除，并记录错误。
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem(ExpireLocalStorage.prefix + key);
          window.console.error('Failed to get localStorage:', error);
        }
        return null;
      }
    }
  }]);
  return ExpireLocalStorage;
}();
_defineProperty(ExpireLocalStorage, "prefix", 'expiring_');
export default ExpireLocalStorage;